import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseQueryResult } from '@tanstack/react-query'
import { usePortalQuery } from 'src/Libs/api'
import { UserInvitationModel } from 'src/Libs/installation-rights-management/models'
import { fetchUserInvitations } from '../api/invitations.api'

export const userInvitationsQueryKey = (uid: number | undefined) => ['user-invitations', uid] as const

/**
 * Fetches open invitations for the current user by their uid.
 * Used to show the invitation pop-up after login
 */
export const useUserInvitations = (uid: number | undefined, isUserLevelUser?: boolean): UseQueryResult<UserInvitationModel[] | null, Error> => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalQuery({
    queryKey: userInvitationsQueryKey(uid),
    queryFn: () => fetchUserInvitations(uid!, authFetch),
    enabled: !!uid && !!isUserLevelUser,
    staleTime: 0,
  })
}
